<template>

    <div v-if="isVisible" :class="classes">
        <icon v-if="messageType == 'danger' || messageType == 'warning'" name="faTriangleExclamation" type="solid"></icon>
        <icon v-if="messageType == 'success'" name="faCircleCheck" type="solid"></icon>
        <p v-html="message"></p>
        <icon v-if="dismissable" name="faXmark" type="solid" @click="dismiss"></icon>
    </div>
</template>

<script>
import script from './StatusMessage';
    export default script;</script>

<style lang="less">
    @import './StatusMessage.less';
</style>